/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { BalanceUnitStatementEntry } from './BalanceUnitStatementEntry';
import {
    BalanceUnitStatementEntryFromJSON,
    BalanceUnitStatementEntryFromJSONTyped,
    BalanceUnitStatementEntryToJSON,
    BalanceUnitStatementEntryToJSONTyped,
} from './BalanceUnitStatementEntry';
import type { IdNameResultOfint } from './IdNameResultOfint';
import {
    IdNameResultOfintFromJSON,
    IdNameResultOfintFromJSONTyped,
    IdNameResultOfintToJSON,
    IdNameResultOfintToJSONTyped,
} from './IdNameResultOfint';
import type { YearlyBalanceSummary } from './YearlyBalanceSummary';
import {
    YearlyBalanceSummaryFromJSON,
    YearlyBalanceSummaryFromJSONTyped,
    YearlyBalanceSummaryToJSON,
    YearlyBalanceSummaryToJSONTyped,
} from './YearlyBalanceSummary';
import type { ApiUserTasksGetPageParameter } from './ApiUserTasksGetPageParameter';
import {
    ApiUserTasksGetPageParameterFromJSON,
    ApiUserTasksGetPageParameterFromJSONTyped,
    ApiUserTasksGetPageParameterToJSON,
    ApiUserTasksGetPageParameterToJSONTyped,
} from './ApiUserTasksGetPageParameter';

/**
 * 
 * @export
 * @interface BalanceUnitStatement
 */
export interface BalanceUnitStatement {
    /**
     * 
     * @type {string}
     * @memberof BalanceUnitStatement
     */
    currency?: string | null;
    /**
     * 
     * @type {number}
     * @memberof BalanceUnitStatement
     */
    totalCharged?: number;
    /**
     * 
     * @type {number}
     * @memberof BalanceUnitStatement
     */
    totalPaid?: number;
    /**
     * 
     * @type {number}
     * @memberof BalanceUnitStatement
     */
    totalAccountCredit?: number;
    /**
     * 
     * @type {number}
     * @memberof BalanceUnitStatement
     */
    outstandingBalance?: number;
    /**
     * 
     * @type {number}
     * @memberof BalanceUnitStatement
     */
    unappliedPaymentAmount?: number;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof BalanceUnitStatement
     */
    user?: IdNameResultOfint | null;
    /**
     * 
     * @type {IdNameResultOfint}
     * @memberof BalanceUnitStatement
     */
    student?: IdNameResultOfint | null;
    /**
     * 
     * @type {Array<BalanceUnitStatementEntry>}
     * @memberof BalanceUnitStatement
     */
    entries?: Array<BalanceUnitStatementEntry>;
    /**
     * 
     * @type {Array<YearlyBalanceSummary>}
     * @memberof BalanceUnitStatement
     */
    yearlyBreakdown?: Array<YearlyBalanceSummary> | null;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof BalanceUnitStatement
     */
    page?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof BalanceUnitStatement
     */
    pageSize?: ApiUserTasksGetPageParameter;
    /**
     * 
     * @type {ApiUserTasksGetPageParameter}
     * @memberof BalanceUnitStatement
     */
    totalCount?: ApiUserTasksGetPageParameter;
}

/**
 * Check if a given object implements the BalanceUnitStatement interface.
 */
export function instanceOfBalanceUnitStatement(value: object): value is BalanceUnitStatement {
    return true;
}

export function BalanceUnitStatementFromJSON(json: any): BalanceUnitStatement {
    return BalanceUnitStatementFromJSONTyped(json, false);
}

export function BalanceUnitStatementFromJSONTyped(json: any, ignoreDiscriminator: boolean): BalanceUnitStatement {
    if (json == null) {
        return json;
    }
    return {
        
        'currency': json['currency'] == null ? undefined : json['currency'],
        'totalCharged': json['totalCharged'] == null ? undefined : json['totalCharged'],
        'totalPaid': json['totalPaid'] == null ? undefined : json['totalPaid'],
        'totalAccountCredit': json['totalAccountCredit'] == null ? undefined : json['totalAccountCredit'],
        'outstandingBalance': json['outstandingBalance'] == null ? undefined : json['outstandingBalance'],
        'unappliedPaymentAmount': json['unappliedPaymentAmount'] == null ? undefined : json['unappliedPaymentAmount'],
        'user': json['user'] == null ? undefined : IdNameResultOfintFromJSON(json['user']),
        'student': json['student'] == null ? undefined : IdNameResultOfintFromJSON(json['student']),
        'entries': json['entries'] == null ? undefined : ((json['entries'] as Array<any>).map(BalanceUnitStatementEntryFromJSON)),
        'yearlyBreakdown': json['yearlyBreakdown'] == null ? undefined : ((json['yearlyBreakdown'] as Array<any>).map(YearlyBalanceSummaryFromJSON)),
        'page': json['page'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['page']),
        'pageSize': json['pageSize'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['pageSize']),
        'totalCount': json['totalCount'] == null ? undefined : ApiUserTasksGetPageParameterFromJSON(json['totalCount']),
    };
}

export function BalanceUnitStatementToJSON(json: any): BalanceUnitStatement {
    return BalanceUnitStatementToJSONTyped(json, false);
}

export function BalanceUnitStatementToJSONTyped(value?: BalanceUnitStatement | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'currency': value['currency'],
        'totalCharged': value['totalCharged'],
        'totalPaid': value['totalPaid'],
        'totalAccountCredit': value['totalAccountCredit'],
        'outstandingBalance': value['outstandingBalance'],
        'unappliedPaymentAmount': value['unappliedPaymentAmount'],
        'user': IdNameResultOfintToJSON(value['user']),
        'student': IdNameResultOfintToJSON(value['student']),
        'entries': value['entries'] == null ? undefined : ((value['entries'] as Array<any>).map(BalanceUnitStatementEntryToJSON)),
        'yearlyBreakdown': value['yearlyBreakdown'] == null ? undefined : ((value['yearlyBreakdown'] as Array<any>).map(YearlyBalanceSummaryToJSON)),
        'page': ApiUserTasksGetPageParameterToJSON(value['page']),
        'pageSize': ApiUserTasksGetPageParameterToJSON(value['pageSize']),
        'totalCount': ApiUserTasksGetPageParameterToJSON(value['totalCount']),
    };
}

